var process = (typeof require != "undefined") ? require("process") : false;
var exec = (typeof require != "undefined") ? require('child_process').exec : false;
var gui = (typeof require != "undefined") ? require('nw.gui') : false;

// Constructor
function Radarsat(datafile) {

	// Holder for game function
	this.game = false;

	// i18n object
	this.i18n = new i18n(this);

	// Audio wrapper
	this.audio = new Audio();

	// Screensaver
	this.resetDelay = 120000;
	// this.resetDelay = 3000000000;

	// Init backgroud animation
	this.bg = {
		"renderer": false,
		"container": false,
		"sky_z0": false,
		"sky_z1": false,
		"sky_z2": false,
		"stage": false,
		"speed": 0.00001,
		"containerSpeed": 0.00001,
		"containerSize": 3840,
		"containerHalfSize": 3840 / 2,
	};
	this.initBg();

	// Init buttons
	this.initButtons();

	// Get preset game name
	if (gui) {
		this.gameName = (gui.App.argv.length > 0) ? gui.App.argv[0] : null;
	} else {
		this.gameName = getURLParameter("game");
	}

	// Launch game if one is specified, otherwise show buttons
	if (this.gameName != false && jQuery.inArray(this.gameName, ["datafilters", "mygarden"]) != -1) {
		this.launch(this.gameName)
	} else {
		$("#triggers").append('<div class="trigger" data-gamename="datafilters">Data filters</div>')
		$("#triggers").append('<div class="trigger" data-gamename="mygarden">My Garden</div>')
		$("#triggers .trigger").one('click', $.proxy(function (e) {
			this.launch($(e.target).data("gamename"));
		}, this))
	}

	// Timeout (screensaver) related
	$(document).on("click", $.proxy(function (e) {
		this.resetTimer();
	}, this));
	setInterval($.proxy(function () {
		this.checkTimer();
	}, this), 1000);

	// Guides toggle
	$("#guide").hide();
	$(window).bind("keydown", $.proxy(function (e) {
		// G key is presse
		if (e.keyCode == 71) {
			$("#guide").toggle();
		} else if (e.keyCode == 27) {
			// Escape
			if (gui) {
				gui.App.quit();
			}
		}
	}, this));
}

Radarsat.prototype.launch = function (gameName) {
	if (this.game == false) {

		// Log game
		console.log("launching " + gameName);

		// Launch game
		if (gameName == "datafilters") {
			// Launch data filters
			this.game = new DataFilters(this);
		} else if (gameName == "mygarden") {
			// Launch my garden
			this.game = new Garden(this);
		} else {
			return false;
		}
	}
}

Radarsat.prototype.start = function () {
	this.game.start();
	$("#title-bar").addClass("in-game");
	$("#bg").addClass("in-game");
};

Radarsat.prototype.reset = function () {
	if(millis() - this.lastReset < 3000 ) {
		return;
	}

	$("#title-bar").removeClass("in-game");
	$("#bg").removeClass("in-game");
	this.lastClick = millis();
	this.lastReset = millis();
	this.game.reset();
};

Radarsat.prototype.initButtons = function () {

	// Init big buttons dynamic action
	$(document).on("click", ".big-button, .help, .rect-button", $.proxy(function (e) {
		var el = $(e.currentTarget);
		if (el.data("action") == "function") {
			var functionName = el.data("function")
			console.log("calling function game." + functionName + "()");
			this.game[functionName]();
		}
	}, this));

	// Init big buttons dynamic action
	$(document).on("click", ".home", $.proxy(function (e) {
		console.log("calling gotoHome()");
		this.reset();
	}, this));

};

Radarsat.prototype.initBg = function () {

	var bgWidth = $("#bg").width();
	var bgHeight = $("#bg").height();

	this.bg.renderer = PIXI.autoDetectRenderer(bgWidth, bgHeight, {backgroundColor: $("#bg").css("background-color")});
	$("#bg").append(this.bg.renderer.view);

	// create the root of the scene graph
	this.bg.stage = new PIXI.Container();

	// create a texture from an image path
	var texturesSources = [
		{"src": "images/sky_z0.jpg", "width": 3840, "height": 3840},
		{"src": "images/sky_z1.png", "width": 3840, "height": 2160},
		{"src": "images/sky_z2.png", "width": 3840, "height": 2160}
	];

	// Add container
	this.bg.container = new PIXI.Container();
	this.bg.container.pivot.x = 3840 / 2;
	this.bg.container.pivot.y = 3840 / 2;
	this.bg.stage.addChild(this.bg.container);

	// create a new Sprite using the texture
	for (var i = 0; i < 3; i++) {
		var texture = PIXI.Texture.fromImage(texturesSources[i].src);
		this.bg["sky_z" + i] = new PIXI.Sprite(texture);
		this.bg["sky_z" + i].position.x = bgWidth * 0.5;
		this.bg["sky_z" + i].position.y = bgHeight * 0.5;
		this.bg["sky_z" + i].alpha = 0.7;
		this.bg["sky_z" + i].pivot.x = texturesSources[i].width * 0.5;
		this.bg["sky_z" + i].pivot.y = texturesSources[i].height * 0.5;
		console.log(this.bg["sky_z" + i]);
		this.bg.container.addChild(this.bg["sky_z" + i]);
	}

	// var graphicsText = PIXI.Texture.fromImage("images/test.jpg");
	// var graphics = new PIXI.Sprite(graphicsText);
	// graphics.position.x = 300;
	// graphics.position.y = 300;
	// graphics.alpha = 0.8;
	// graphics.blendMode = PIXI.BLEND_MODES.SCREEN;
	// this.bg.stage.addChild(graphics);

	this.animateBg();
};


Radarsat.prototype.animateBg = function (timestamp) {

	requestAnimationFrame($.proxy(this.animateBg, this));

	// just for fun, let's rotate mr rabbit a little
	this.bg.sky_z0.rotation += 3 * this.bg.speed;
	this.bg.sky_z1.rotation += 2 * this.bg.speed;
	this.bg.sky_z2.rotation += 1 * this.bg.speed;
	this.bg.container.x = Math.cos(timestamp * this.bg.containerSpeed) * 500 + this.bg.containerHalfSize;
	this.bg.container.y = Math.sin(timestamp * this.bg.containerSpeed) * 500 + this.bg.containerHalfSize;

	// render the container
	this.bg.renderer.render(this.bg.stage);
}

Radarsat.prototype.resetTimer = function (data) {
	this.lastClick = millis();
}

Radarsat.prototype.checkTimer = function (data) {
	var noActionSince = millis() - this.lastClick;
	if (noActionSince > this.resetDelay) {
		this.reset();
	}
}

Radarsat.prototype.initSVG = function () {

	$('img.svg').each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.ajax({
			url: imgURL,
			success: $.proxy(function ($img, imgID, imgClass, data) {
				// Get the SVG tag, ignore the rest
				var $svg = $("<div>" + data + "</div>").find('svg');
				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}
				// Remove any invalid XML tags as per http:validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}, this, $img, imgID, imgClass),
			dataType: "text"
		});
	});
}

// Expose Radarsat
window.Radarsat = Radarsat;
